"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * 事件绑定
 *
 * @param el
 * @param type
 * @param func
 * @param isRemoving
 */
var event = {
    on: function (el, type, func, isRemoving) {
        if (el.addEventListener) {
            el.addEventListener(type, isRemoving ? function () {
                el.removeEventListener(type, func, false);
                func();
            } : func, false);
        }
        else if (el.attachEvent) {
            el.attachEvent('on' + type, function () {
                if (isRemoving) {
                    el.detachEvent('on' + type, arguments.callee);
                }
                func();
            });
        }
    },
    getArea: function () {
        var win = window;
        var host = win && win.location.host;
        if (host.indexOf('sg.cainiao.com') >= 0) {
            return 'sg';
        }
        else if (host.indexOf('ru.cainiao.com') >= 0) {
            return 'ru';
        }
        else {
            return 'cn';
        }
    },
    addEvent: function (ele, evnt, func) {
        var elem = ele || window.document;
        if (elem.addEventListener) { // W3C DOM
            elem.addEventListener(evnt, func, true);
        }
        else if (elem.attachEvent) { // IE DOM
            elem.attachEvent("on" + evnt, func);
        }
        else {
            elem[evnt] = func;
        }
    },
    removeEvent: function (ele, evnt, func) {
        var elem = ele || window.document;
        if (elem.removeEventListener) { // W3C DOM
            elem.removeEventListener(evnt, func, true);
        }
        else if (elem.detachEvent) { // IE DOM
            elem.detachEvent("on" + evnt, func);
        }
        else {
            elem[evnt] = func;
        }
    },
};
exports.default = event;
//# sourceMappingURL=event.js.map